import React from 'react';
import PropTypes from 'prop-types';
import { STL_SOURCES } from '../constants/stlSources';
import './css/StlSourceRadio.css'; // Assuming external CSS file

const StlSourceRadio = ({ currentSource }) => {
  return (
    <div className="stl-radio-container">
      <h4 className="title">Stl Files Storage Reference</h4>
      
      <div className="stl-options-group">
        {STL_SOURCES.map((source) => {
          const isChecked = currentSource === source.id;
          
          return (
            <label 
              key={source.id} 
              className={`radio-label ${isChecked ? 'selected' : ''}`}
            >
              <input
                type="radio"
                name="stlSource"
                value={source.id}
                checked={isChecked}
                readOnly // React specific: makes it immutable without "disabled" styling
                disabled={!isChecked} // Optional: strictly disable non-selected items
              />
              <span className="radio-text">{source.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

StlSourceRadio.propTypes = {
  currentSource: PropTypes.string.isRequired,
};

export default StlSourceRadio;